module.exports = __webpack_public_path__ + "img/bg4.6c7cef47.jpg";